// extracted by mini-css-extract-plugin
module.exports = {"loadingContainer":"BaseLoading_loadingContainer_1hmGT","spinAround":"BaseLoading_spinAround_gUGri"};